module.exports = __webpack_public_path__ + "img/dot-chart.57ed703d.svg";